import { Paths, Urls } from "../constants/UrlConstants";
import React from "react";
import { Link } from "react-router-dom";
import HealthSupportPromoSrc from "../assets/img/card-images/Access-Health-Support_1112-x-646.jpg";
import HealthSupportPromoSrcMobile from "../assets/img/card-images/Health-Support-mobile-promo_580x340.jpg";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import HowToClaim from "./HowToClaim";
import { Layouts } from "../constants/Constants";
import { getLayout } from "../layout/Layout";
import linkStyles from "../assets/css/modules/shared/link.css";

const Claims = {
  MyClaimsSection: {
    Header: {
      Any:(<h2>My claims</h2>),
      Format2:(<h2>Claims and claim updates</h2>)
    },
    Body: {
      Any: (
        <p>
          The latest details about the claims that you've made and any actions
          that you need to take can be found here. Don't forget, if you've any
          medical questions we've a range of{" "}
          <Link
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            to={Paths.HealthSupport}
          >
            health information and support{" "}
          </Link>
          that may help you on your road to recovery.
        </p>
      ),
      HOL: (
        <p>
          The latest details about the claims that you've made and any actions
          that you need to take can be found here. Don't forget, if you've any
          medical questions we've a range of{" "}
          <Link
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            to={Paths.HealthHub}
          >
            health information and support{" "}
          </Link>
          that may help you on your road to recovery.
        </p>
      ),
      Format2: (
        // <p>
        //   The latest details about the claims that you’ve made and any actions
        //   that you need to take can be found here.
        // </p>
        <></>
      )
    }
  },
  RecentlySubmittedSection: {
    Header: <h3>Recently submitted a new claim online?</h3>,
    Body: {
      Format2: (
        <p>
          If you’ve recently submitted a new claim and it’s not shown above,
          please go to your inbox to view the claim. Once it’s been reviewed,
          it’ll appear above.
        </p>
      ),
      Any: (
        <p>
          If you have recently submitted a new claim and it's not shown above,
          please go to your inbox to view the claim. Once we've reviewed your
          claim, it'll appear above.
        </p>
      )
    }
  },
  AllClaimsSection: {
    Header: {
      Any:<h3>All claims</h3>,
      Format2:<></>,
    },
    Body: {
      Format2: (
        // <p>
        //   All of your claims that have been reviewed by our team can be seen
        //   below. You can view and download the benefit statement for each claim
        //   to see more details. Please enable pop-ups when viewing them on
        //   tablets and phones.<br></br>
        //   Any reference to Doctor@Hand claims show the use of a service under the plan. 
        //   They have no costs associated with them and do not affect any benefits on your plan.

        // </p>
        <></>
      ),
      Any: (
        <p>
          All of your claims that have been reviewed by our team can be seen
          below. Click on 'View claim' to see further details for each one,
          including payments. Please enable pop-ups when viewing them on tablets
          and phones.<br></br>
          Any reference to Doctor@Hand claims show the use of a service under the plan. 
          They have no costs associated with them and do not affect any benefits on your plan.

        </p>
      )
    },
    GetStartedText: "Get started with a new claim"
  },
  ClaimsSectionCrest:{
    LoadMore:"Load More",
    showing:"Showing",
    scrollSectionLabel:"Scroll down to view your claim updates"
  },
  ClaimsSectionCrestHeader:{
    Any:(<h3>Claims</h3>)
  },
  ClaimsSectionCrestBody: (url) => [
    {
      Content:(
        <p>
          If you’ve recently submitted a new claim that’s not showing below, it’ll currently be       under review. Once reviewed, you’ll find it here. You can check your submitted claims in your {" "} 
          <a
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            href={url}
            target="_blank"
            rel="noopener"
          >
                      inbox.
                    </a>
        </p>
      ),
  }],
  ClaimsUpdateSectionCrest:{
    Header:<h3>Claim updates</h3>,
    Body:{
      Any:(
        <p>
          You’ll find your claim updates here. They show the cost of your treatment, what we’ve paid and any contribution you need to make. To view and download them for more details, please enable pop-ups on your device. 
        </p>
      )
    }
  },
  TextForNoClaimsConditions: "There are currently no claims for this member.",
  TextForNoClaimsSummary: "There are currently no invoices for this member.",
  GoToInboxLabel: "Go to inbox",
  ViewClaimsForLabel: "View claims details for",

  ViewClaimsToolTip: {
    HOL:
      "You can also see any claims made by anyone on your policy, under the age of 16, by using the dropdown above. Once they reach 16, you'll no longer be able to view their claims, so they'll need to register for their own online account.",
    Any:
      "You can also see any claims made by anyone on your plan, under the age of 16, by using the dropdown above. Once they reach 16, you'll no longer be able to view their claims, so they'll need to register for their own online account."
  },
  ViewClaimsToolTipOAD: {
    Any:
      "You cannot manage or see claims online for anyone over the age of 16 on your plan.",
    HOL:
      "You cannot manage or see claims online for anyone over the age of 16 on your policy."
  },
  ViewClaimsToolTipOADloggedin: {
    HOL:
      "You cannot manage or see claims online for anyone else on this policy.",
    Any:
      "You cannot manage or see claims online for anyone else on this plan."
  },

  HelpSection: {
    HeadingLinkTo: Paths.Help,
    HeadingLinkText: "Help",
    MoreHelpLinkTo: Paths.Help,
    MoreHelpLinkText: "View more help"
  },
  HelpSetEP: (AuthUrl, ClaimBackUrl,IsInternalView) => [
    {
      Question: "How do I authorise a new treatment?",
      Answer: {
        Any: IsInternalView?(
          <p>
            If you have a new treatment to authorise, please {"  "}
            <Link to="/" 
            className={linkStyles.disabled} 
            onClick={ (event) => event.preventDefault() }>
            contact us to check if your membership covers your treatment.{" "}
            </Link>
          </p>
        ):(
          <p>
            If you have a new treatment to authorise, please {"  "}
            <a
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            href={AuthUrl}
            target="_blank"
            rel="noopener"
          >
            contact us to check if your membership covers your treatment.{" "}
          </a>
          </p>
        ),
        Format2: IsInternalView?(
          <p>
            If you have a new treatment to authorise, please {"  "}
            <Link to="/" 
            className={linkStyles.disabled} 
            onClick={ (event) => event.preventDefault() }>
            contact us to check if your membership covers your treatment.{" "}
            </Link>
          </p>
          ):(
          <p>
            If you have a new treatment to authorise, please {"  "}
            <a
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            href={AuthUrl}
            target="_blank"
            rel="noopener"
            >
              contact us to check if your membership covers your treatment.{" "}
            </a>
        </p>
        ),
        //for AGH or international members
        International: (
          <p>
            If you have a new treatment to authorise, please click on the 'Make
            a claim' button from your Home page or 'My claims'. Then select
            'Check cover for treatment'.
          </p>
        )
      }
    },
    {
      Question: "How do I upload a new invoice for treatment?",
      Answer: {
        Any: IsInternalView?(
          <p>
            If you have a new invoice to send us, you can {"  "}
            <Link to="/" 
            className={linkStyles.disabled} 
            onClick={ (event) => event.preventDefault() }>
            upload your documents here.{" "}
            </Link>
          </p>
          ):(
          <p>
            If you have a new invoice to send us, you can {"  "}
            <a
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            href={ClaimBackUrl}
            target="_blank"
            rel="noopener"
          >
            upload your documents here.{" "}
          </a>
          </p>
        ),
        Format2: IsInternalView?(
          <p>
            If you have a new invoice to send us, you can {"  "}
            <Link to="/" 
            className={linkStyles.disabled} 
            onClick={ (event) => event.preventDefault() }>
            upload your documents here.{" "}
            </Link>
          </p>
          ):(
          <p>
            If you have a new invoice to send us, you can {"  "}
            <a
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            href={ClaimBackUrl}
            target="_blank"
            rel="noopener"
          >
            upload your documents here.{" "}
          </a>
          </p>
        )
      }
    },
    {
      Question: "How do I view payment details for my claim?",
      Answer: {
        Any: (
          <p>
            To view the payment details for your claims, please go to the claim
            details page for the claim you want to view. Then click on the 'View
            payments' button. You will be able to view details for any payments
            that we have assessed.
          </p>
        ),
        Format2: (
          <p>
            To view the payment details for your claims, please download the
            relevant benefit statement on 'My claims'. This will show what's
            been paid.
          </p>
        )
      }
    }
  ],
  HelpSet: [
    {
      Question: "How do I authorise a new treatment?",
      Answer: {
        Any: (
          <p>
            If you have a new treatment to authorise, please go to claim details
            page and click on the 'Authorise treatment' button. Alternatively,
            you can click on the 'Make a claim' button from your Home page or
            'My claims'.
          </p>
        ),
        Format2: (
          <p>
            If you have a new treatment to authorise, please click on the 'Make
            a claim' button from your Home page or 'My claims'. Then select
            'Authorise a treatment or appointment'.
          </p>
        ),
        //for AGH or international members
        International: (
          <p>
            If you have a new treatment to authorise, please click on the 'Make
            a claim' button from your Home page or 'My claims'. Then select
            'Check cover for treatment'.
          </p>
        )
      }
    },
    {
      Question: "How do I upload a new invoice for treatment?",
      Answer: {
        Any: (
          <p>
            If you have a new invoice to upload, please go to claim details page
            and click on the 'Upload invoice' button. Alternatively, you can
            click on the 'Make a claim' button from your Home page or 'My
            claims'.
          </p>
        ),
        Format2: (
          <p>
            If you have a new invoice to upload, please click on the 'Make a
            claim' button from your Home page or 'My claims'. Then select 'Claim
            back for payments you've made'.
          </p>
        )
      }
    },
    {
      Question: "How do I view payment details for my claim?",
      Answer: {
        Any: (
          <p>
            To view the payment details for your claims, please go to the claim
            details page for the claim you want to view. Then click on the 'View
            payments' button. You will be able to view details for any payments
            that we have assessed.
          </p>
        ),
        Format2: (
          <p>
            To view the payment details for your claims, please download the
            relevant benefit statement on 'My claims'. This will show what's
            been paid.
          </p>
        )
      }
    }
  ],
  Promo: {
    Description: {
      Any:
        "We're here to support you with your health, every step of the way. Explore how we can help you and your family.",
      International:
        "We offer you an independent second opinion at no extra cost. We'll assign a personal case manager and nurse to support you at every step."
    },
    Heading: {
      International: "Second medical opinion",
      HOL: "Access my health hub",
      Any: "Access health support"
    },
    ImgSrc: {
      International: HealthSupportPromoSrc,
      Any: HealthSupportPromoSrc
    },
    ImgSrcMobile: {
      International: HealthSupportPromoSrcMobile,
      Any: HealthSupportPromoSrcMobile
    },
    LinkText: {
      International: "Discover",
      HOL: "Health hub",
      Any: "Health support"
    },
    LinkTo: {
      Any: Paths.HealthSupport,
      HOL: Paths.HealthHub,
      International: Urls.InternationalSecondOpinion
    }
  },
  BenefitStatementPdfLinkLabel: "Benefit Statement",
  LoadingMessage: "Please wait...",
  PaymentNeededText: "Payment shortfalled",
  PaymentNeededTooltipText:
    "This claim has a shortfall payable by you. Your healthcare provider should be in touch about payment. Download the benefit statement above to see the details of what you need to pay. If you've already paid the shortfall, you don't need to do anything.",
  ClaimNumberLabel: "Claim assessment number",
  AvailableDatelabel: "Statement date",
  AmountClaimedLabel: "Submitted",
  AmountPaidLabel: "Paid",
  ClaimNumber:"Claim number",
  Lastupdated:"Last updated:"
};

if (
  !window?.axa?.features?.healthUnlockedFeature &&
  getLayout() === Layouts.HOL
) {
  Claims.Promo = {
    ...HowToClaim.AskMedExpert,
    ImgSrc: HowToClaim.AskMedExpert.IconSrc,
    ImgSrcMobile: HowToClaim.AskMedExpert.IconSrcMobile
  };
}

export default Claims;
